// トップページ用 JavaScript
// GPS検索・住所検索・トースト通知を担当

document.addEventListener("DOMContentLoaded", () => {
  setupGpsSearch();
  setupAddressSearch();
});

// ─── GPS 検索 ────────────────────────────────────────────────────────────────

function setupGpsSearch() {
  const btn = document.getElementById("gps-search-btn");
  if (!btn) return;

  btn.addEventListener("click", () => {
    if (!navigator.geolocation) {
      showToast(
        "お使いのブラウザは位置情報に対応していません。別の方法で場所を指定してください。",
        "user"
      );
      return;
    }

    setButtonState(btn, true, "取得中…");

    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude: lat, longitude: lng } }) => {
        window.location.href = `map?ll=${lat},${lng}&z=15`;
      },
      (err) => {
        setButtonState(btn, false, "現在地付近を検索（GPS）");
        const msg =
          err.code === err.PERMISSION_DENIED
            ? "位置情報の利用が許可されていません。ブラウザの設定をご確認ください。"
            : "位置情報の取得に失敗しました。別の方法で場所を指定してください。";
        showToast(msg, "user");
      },
      { timeout: 10000 }
    );
  });
}

// ─── 住所・駅名検索 ───────────────────────────────────────────────────────────

function setupAddressSearch() {
  const form = document.getElementById("address-search-form");
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const input = document.getElementById("address-search-input");
    const btn = document.getElementById("address-search-btn");
    const query = input?.value.trim();

    if (!query) return;

    setButtonState(btn, true, "検索中…");

    try {
      const res = await fetch(
        `/api/v2/geocoding?q=${encodeURIComponent(query)}`
      );
      const data = await res.json();

      if (res.ok && data.status === "OK") {
        // ジオコーディング成功 → 地図ページへ遷移
        const encodedName = encodeURIComponent(query);
        window.location.href = `map/${encodedName}?ll=${data.lat},${data.lng}&z=15`;
        return; // ページ遷移開始のため以降は不要
      }

      if (res.status < 500) {
        // 4xx: ユーザー起因（地名不明など）
        showToast(
          `「${query}」の場所を特定できませんでした。別の地名や住所でお試しください。`,
          "user"
        );
      } else {
        // 5xx: サーバー・外部API起因
        showToast(
          "検索中にエラーが発生しました。しばらくしてから再試行してください。",
          "system"
        );
        reportError("Geocoding API server error", {
          query,
          status: data.status,
          httpStatus: res.status,
        });
      }
    } catch (err) {
      // ネットワークエラーなど
      showToast(
        "検索中にエラーが発生しました。ネットワーク接続をご確認ください。",
        "system"
      );
      reportError("Geocoding network error", { query, message: err.message });
    } finally {
      setButtonState(btn, false, "検索");
    }
  });
}

// ─── ユーティリティ ───────────────────────────────────────────────────────────

function setButtonState(btn, disabled, label) {
  if (!btn) return;
  btn.disabled = disabled;
  btn.textContent = label;
}

/**
 * Rollbar へエラーを送信する（JS SDK が未ロードの場合はスキップ）
 * @param {string} message
 * @param {object} context
 */
function reportError(message, context) {
  if (typeof window !== "undefined" && window.Rollbar) {
    window.Rollbar.error(message, context);
  }
}

/**
 * トースト通知を表示する
 * @param {string} message - 表示メッセージ
 * @param {"user"|"system"} type - "user": ユーザー起因, "system": システム起因
 */
function showToast(message, type = "user") {
  const container = document.getElementById("toast-container");
  if (!container) return;

  const toast = document.createElement("div");
  const isSystem = type === "system";

  toast.setAttribute("role", "alert");
  toast.className = [
    "flex items-start gap-3 px-4 py-3 rounded-xl text-sm font-medium",
    "shadow-[0px_8px_24px_rgba(25,28,32,0.18)]",
    isSystem ? "bg-[#7f5400] text-white" : "bg-[#191c20] text-white",
  ].join(" ");

  const icon = document.createElement("span");
  icon.setAttribute("aria-hidden", "true");
  icon.textContent = isSystem ? "⚠️" : "ℹ️";
  icon.className = "mt-0.5 shrink-0";

  const text = document.createElement("span");
  text.textContent = message;
  text.className = "flex-1";

  const closeBtn = document.createElement("button");
  closeBtn.setAttribute("aria-label", "閉じる");
  closeBtn.className = "ml-auto text-white/70 hover:text-white shrink-0 leading-none";
  closeBtn.textContent = "×";
  closeBtn.addEventListener("click", () => toast.remove());

  toast.appendChild(icon);
  toast.appendChild(text);
  toast.appendChild(closeBtn);
  container.appendChild(toast);

  // 6秒後に自動削除
  const timer = setTimeout(() => toast.remove(), 6000);
  // 手動で閉じた場合もタイマーをクリア
  closeBtn.addEventListener("click", () => clearTimeout(timer), { once: true });
}
